import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogHeader,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import { AgreementRenderer } from '@/features/account/components/AgreementRenderer'

export interface ViewAcceptedTermsDialogProps {
  isOpen: boolean
  termsMarkup: string
  onClose: () => void
  testId?: string
  confirmButtonTestId?: string
}

/**
 * Dialog for viewing accepted terms of use
 */
export function ViewAcceptedTermsDialog({
  isOpen,
  termsMarkup,
  onClose,
  testId,
  confirmButtonTestId,
}: ViewAcceptedTermsDialogProps) {
  return (
    <ModalDialog
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      aria-label="Terms of Use"
      testId={testId}
    >
      <ModalDialogHeader />
      <ModalDialogContent>
        <AgreementRenderer markup={termsMarkup} />
      </ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button label="OK" onPress={onClose} testId={confirmButtonTestId} />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
